module.exports = __webpack_public_path__ + "img/act_to_adapt.91b228ac.png";